import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { hideCreateDialog } from '../../store/slice/dialogSlice'
import {
  updateGroupData,
  updateOrderData,
  updateRequestData,
  updateUserData,
  updateVendorData,
} from '../../store/slice/mainToCardSlice'
import { updatePaymentCardSlice } from '../../store/slice/paymentSlice'
import { onCreateSup } from '../../store/slice/otherSlice'

const CreateDialog = () => {
  const paymentCardSlice = useSelector((state) => state.paymentSlice.paymentCardSlice)
  const open = useSelector((state) => state.dialogSlice.createDialog)
  const dispatch = useDispatch()
  const handleClose = () => {
    dispatch(hideCreateDialog())
  }
  const navigate = useNavigate()

  let content, action
  const url = useLocation().pathname

  switch (url) {
    case '/groups':
      content = <>Group</>
      action = (
        <Button
          variant="contained"
          onClick={() => {
            navigate(`groups/0`)
            dispatch(updateGroupData([]))
            handleClose()
          }}
        >
          Create
        </Button>
      )
      break
    case '/users':
      content = <>User</>
      action = (
        <Button
          variant="contained"
          onClick={() => {
            navigate(`users/0`)
            dispatch(updateUserData([]))
            handleClose()
          }}
        >
          Create
        </Button>
      )
      break
    case '/requests':
      content = <>Request</>
      action = (
        <Button
          variant="contained"
          onClick={() => {
            navigate(`requests/0`)
            dispatch(updateRequestData([]))
            handleClose()
          }}
        >
          Create
        </Button>
      )
      break
    case '/approval-stages':
      content = <>Approval Stage</>
      action = (
        <Button
          variant="contained"
          onClick={() => {
            navigate(`approval-stages/0`)
            dispatch(updateRequestData([]))
            handleClose()
          }}
        >
          Create
        </Button>
      )
      break
    case '/vendors':
      content = <>Vendor</>
      action = (
        <>
          <Button
            variant="contained"
            onClick={() => {
              navigate(`supplier-evaluation/0`)
              // localStorage.setItem('reviseId', 0)
              // dispatch(updateVendorData([]))
              dispatch(onCreateSup())
              handleClose()
            }}
          >
            Simple Vendor
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              navigate(`individual-vendor`)
              handleClose()
            }}
          >
            Individual Vendor
          </Button>
        </>
      )
      break
    case '/rfqs':
      content = <>RFQ</>
      action = (
        <Button
          variant="contained"
          onClick={() => {
            navigate(`rfqs/0`)
            dispatch(updateVendorData([]))
            handleClose()
          }}
        >
          Create
        </Button>
      )
      break
    case '/bids':
      content = <>BIDs</>
      action = (
        <Button
          variant="contained"
          onClick={() => {
            navigate(`bids/0`)
            dispatch(updateVendorData([]))
            handleClose()
          }}
        >
          Create
        </Button>
      )
      break
    case '/payment':
      content = <>Payment</>
      action = (
        <Button
          variant="contained"
          onClick={() => {
            navigate(`payment-create`)
            dispatch(
              updatePaymentCardSlice({
                ...paymentCardSlice,
                vendorCode: '',
                vendorName: '',
                currencyCode: '',
                details: [],
              })
            )
            handleClose()
          }}
        >
          Create
        </Button>
      )
      break
    case '/orders':
      content = <>Order</>
      action = (
        <Button
          variant="contained"
          onClick={() => {
            navigate(`ordersList`)
            dispatch(updateOrderData([]))
            handleClose()
          }}
        >
          Create
        </Button>
      )
      break
    case '/invoice-register':
      content = <>Invoice</>
      action = (
        <Button
          variant="contained"
          onClick={() => {
            dispatch(updateOrderData([]))
            handleClose()
          }}
        >
          Create
        </Button>
      )
      break
    default:
      content = null
      break
  }

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Create</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText>Do you want to create a new {content}?</DialogContentText>
        </DialogContent>
        <DialogActions>
          {action}
          <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default CreateDialog
